'use client'

import dynamic from "next/dynamic"
import React from "react"
import LoadingData from "../component/LoadingData"
const MarketAuther = dynamic(()=>import('../component/Marketplace/MarketAuther'),{
    ssr:false,
    loading: () => <LoadingData />,
});
const MarketPartner = dynamic(()=>import('../component/Marketplace/MarketPartner'),{
    ssr:false,
    loading: () => <LoadingData />,
});

const MarketPlace = ({data,type}) => {

    if (!data?.market_data) {
        return (
            <div role="alert" className="min-h-[50vh] flex items-center justify-center px-6 py-12 text-center text-primary">
                ไม่พบข้อมูลร้านค้า กรุณาลองโหลดหน้าอีกครั้ง
            </div>
        );
    }

    return(
        <div className="max-w-[1200px] mx-auto">
            {type === 'a' ?
                <MarketAuther data={data} />
            :
                <MarketPartner data={data} />
            }
        </div>
    )
}

export default MarketPlace
